const setTimeStamp = function () {
  const timeStamp = new Date()
  const year = timeStamp.getFullYear()
  const month = timeStamp.getMonth() + 1
  const day = timeStamp.getDate()
  const hour = timeStamp.getHours()
  const minutes = timeStamp.getMinutes()
  const seconds = timeStamp.getSeconds()
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
}

export default setTimeStamp
